import server from '../server'
import shared from '~shared'


export default {
  data() {
    return {
      loading: false,
      invalid: false,
      loggedIn: false,
      error: null,
      username: '',
      password: ''
    }
  },

  methods:{
    login(){
      if(!this.username || !this.password) return
      this.loading = true
      this.invalid = false

      server.login(this.username, this.password)
      .then(result => {
        this.loading = false
        this.invalid = !result.success
        
        if(result.success){
          try{ //just to make sure everything works smooth in IE version without the AutoCompleteSaveForm function. typeof window.external.AutoCompleteSaveForm != function on IE
            window.external.AutoCompleteSaveForm(this.form.form.el.dom);
          }catch(e){}
          shared.login.success = true
          this.$router.STOP = true // stop router from redirecting our new route to rails
          
          let href = '/'
          if(this.$route.query.to) href += '#' + this.$route.query.to

          window.location.href = href //reload on successfull login
          
        }
      })
      .catch(error => {
        this.loading = false
        this.error = error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/login/mixins/login.js